import listReducer from '../common/list-reducer';
import listItemReducer from '../common/list-item-reducer';


import postEventReducer from './reducer.postEventResult';
import {getEventAction} from "./actions";

const eventsInfoReducer = listItemReducer.bind(getEventAction.getListReduceThisObj());

export default ({
    eventsInfo: eventsInfoReducer,
    postEventInfoResult: postEventReducer,
});